module.exports = __webpack_public_path__ + "img/3.04.a7a38b21.jpg";